<span [class]="contentClass" class="skeleton_item overflow-hidden">
  <span class="skeleton_item"></span>
</span>
